/**
 * Appearance Constants
 *
 * Source-of-truth for the colour-scheme preference used across the frontend
 * (the appearance tabs, the theme bootstrapper, and anything that mirrors the
 * user's mode into a third-party widget). `SYSTEM` means "follow the OS", so
 * it is never written onto the document — it resolves to light or dark.
 */
export const APPEARANCES = {
    LIGHT: 'light',
    DARK: 'dark',
    SYSTEM: 'system',
} as const;

export type Appearance = (typeof APPEARANCES)[keyof typeof APPEARANCES];

/**
 * Key the preference is persisted under, in both `localStorage` (client-side
 * persistence) and the SSR cookie of the same name.
 */
export const APPEARANCE_STORAGE_KEY = 'appearance';
